<template>
    <div class="col-sm-12">
        <h1>Title A/B Testing</h1>

        <h2 class="h5 h-aside is-toggable-mobile">
            Filters
        </h2>

        <div class="flex">
            <div class="form-group">
				<label for="accountManager">Account Manager</label>
                <select class="form-control" v-model="filter.accountManager" @change="filterData">
                    <option value="">Please select</option>
                    <option v-for="aM in staticData.accountManagers" :value="aM.id">{{ aM.name }}</option>
                </select>
			</div>
			<div class="form-group" style="margin-left: 20px">
				<label>Employer:</label>
				<input type="text" name="filterEmployer" v-model="filter.employer" class="form-control">
			</div>
			<div class="form-group" style="margin-left: 20px">
				<label>Job:</label>
				<input type="text" name="filterJob" v-model="filter.job" class="form-control">
			</div>
			<div class="form-group" style="margin-left: 20px">
				<label>Title:</label>
				<input type="text" name="filterTitle" v-model="filter.title" class="form-control">
			</div>
			<div class="form-group" style="margin-left: 20px">
				<label for="frm-states">Active</label>
                 <select class="form-control" v-model="filter.active" @change="filterData" style="max-width: 200px">
                    <option v-for="item in staticData.activeFilterList" :value="item.value">{{ item.text }}</option>
                </select>
			</div>
			<div class="form-group" style="margin-left: 20px">
				<label for="from">From</label>
				<input type="date" name="filterFrom" v-model="filter.from" class="form-control">
			</div>
			<div class="form-group" style="margin-left: 20px">
				<label for="to">To</label>
				<input type="date" name="filterTo" v-model="filter.to" class="form-control">
			</div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <a :href="getCsvExportUrl" type="submit" class="btn btn-default is-aligned-right">
                    <span aria-hidden="true" class="fa fa-list-alt"></span> Export to CSV</a>
            </div>
        </div>

    	<div class="alert alert-warning" v-if="filteredData.length == 0 && ! isBusy">
            No data found.
        </div>
        <div class="table-responsive" v-else>
            <table class="table table-striped table-hover">
                <tbody>
                    <tr>
                        <sorting-header column="name" :sort="sortBy" :direction="sortByDirection" @sorted="sortTable">
                            Employer
                        </sorting-header>
                        <sorting-header column="title" :sort="sortBy" :direction="sortByDirection" @sorted="sortTable">
                            Job
                        </sorting-header>
                        <sorting-header column="alt_title" :sort="sortBy" :direction="sortByDirection" @sorted="sortTable">
                            Title
                        </sorting-header>
                        <sorting-header column="display_count" :sort="sortBy" :direction="sortByDirection" @sorted="sortTable">
                            Display #
                        </sorting-header>
                        <sorting-header column="click_count" :sort="sortBy" :direction="sortByDirection" @sorted="sortTable">
                            Click #
                        </sorting-header>
                        <sorting-header column="ctr" :sort="sortBy" :direction="sortByDirection" @sorted="sortTable">
                            CTR
                        </sorting-header>
                    </tr>
                    <tr v-for="(row, key) in filteredData">
                        <td>{{ row.name }}</td>
                        <td>{{ row.title }}</td>
                        <td>{{ row.alt_title }}</td>
                        <td>{{ row.display_count }}</td>
                        <td>{{ row.click_count }}</td>
                        <td>
                            <span v-if="row.ctr">
                                {{ (row.ctr * 100).toFixed(2) }}%
                            </span>
                            <span v-else>
                                -
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <busy-spinner :is-on="isBusy"></busy-spinner>
    </div>
</template>

<script>
    export default {
        props: [
            'staticData'
        ],
        data() {
            return {
                data: null,
                filteredData: [],
                filter: {
                    accountManager: '',
                    employer: null,
                    job: '',
                    title: '',
                    active: 'Active',
                    from: moment().subtract(3, 'months').format('YYYY-MM-DD'),
                    to: moment().format('YYYY-MM-DD'),
                },
                sortBy: null,
                sortByDirection: null,
                isBusy: false
            };
        },
        watch: {
            'filter.accountManager': function() {
                this.initialize();
            },
            'filter.employer': function () {
                this.filterData();
            },
            'filter.job': function () {
                this.filterData();
            },
            'filter.title': function () {
                this.filterData();
            },
            'filter.active': function () {
                this.initialize();
            },
            'filter.from': function () {
                this.initialize();
            },
            'filter.to': function () {
                this.initialize();
            }
        },
        computed: {
            getDataUrl() {
                return url('admin/reports/ab-test/data');
            },
            getCsvExportUrl() {
                return url(encodeURI(
                    'admin/reports/ab-test/csv-export' +
                    `?account_manager_id=${this.filter.accountManager === null ? '' : this.filter.accountManager}` +
                    `&employer_name=${this.filter.employer === null ? '' : this.filter.employer}` +
                    `&job_title=${this.filter.job === null ? '' : this.filter.job}` +
                    `&job_alt_title=${this.filter.title === null ? '' : this.filter.title}` +
                    `&only_active=${this.filter.active === 'Active' ? 1 : 0}` +
                    `&from=${this.filter.from}` +
                    `&to=${this.filter.to}`,
                ));
            },
        },
        methods: {
            filterData(){
                this.filteredData = _.cloneDeep(this.data);

                if(this.filter.employer) {
                    let filterEmployerLowerCase = this.filter.employer.toLowerCase();

                    this.filteredData = _.filter(this.filteredData, (item) => {
                        let employerLowerCase = item.name.toLowerCase();

                        return employerLowerCase.indexOf(filterEmployerLowerCase) !== -1;
                    });
                }

                // "Job" column (but "title" in object)
                if(this.filter.job) {
                    let filterJobLowerCase = this.filter.job.toLowerCase();

                    this.filteredData = _.filter(this.filteredData, (item) => {
                        let titleLowerCase = item.title.toLowerCase();

                        return titleLowerCase.indexOf(filterJobLowerCase) !== -1;
                    });
                }

                // "Title" column (but "alt_title" in object)
                if(this.filter.title) {
                    let filterTitleLowerCase = this.filter.title.toLowerCase();

                    this.filteredData = _.filter(this.filteredData, (item) => {
                        let titleLowerCase = item.alt_title.toLowerCase();

                        return titleLowerCase.indexOf(filterTitleLowerCase) !== -1;
                    });
                }

                return this.filteredData;
            },
            sortTable(params){
                let column = params.col;
                let direction = params.dir;
                this.sortBy = column;
                this.sortByDirection = direction;

                this.filteredData = _.orderBy(this.filteredData, column, direction);
            },
            initialize(){
                this.makeGet(this.getDataUrl,
                    {
                        accountManager: this.filter.accountManager,
                        filter: this.filter.active,
                        from: this.filter.from,
                        to: this.filter.to
                    },
                    (data) => {
                        this.data = data;
                        this.filterData()
                    })
            }
        },
        mounted: function(){
            this.initialize();
        }
    }
</script>
